<template>
  <div class="app_contain_w site_min_w">
    <MyTop />
    <MyHeader />
    <MyNav />

    <MyMain v-if="$route.path === '/'" />
    <router-view v-else />

    <MyFooter />
    <!-- 固定导航栏 -->
    <SiteFixedNav />
  </div>
</template>

<script>
import MyHeader from '@/views/public_0983cc/MyHeader.vue'
import MyFooter from '@/views/public_0983cc/MyFooter.vue'
import MyTop from '@/views/public_0983cc/MyTop.vue'
import MyNav from '@/views/public_0983cc/MyNav.vue'
import SiteFixedNav from '@/components/base/SiteFixedNav.vue'
import MyMain from './home/index.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Async',
  components: {
    MyHeader,
    MyFooter,
    MyTop,
    MyNav,
    SiteFixedNav,
    MyMain
  },
  metaInfo() {
    return {
      title: this.siteInfo?.name
    }
  },
  computed: {
    ...mapGetters(['siteInfo'])
  },
  watch: {
    $route(n) {
      if (n.path === '/') {
        this.initNodeSubsets([
          {
            code: 'news',
            nodeRows: 3,
            dataRows: 6
          },
          {
            code: 'notice',
            nodeRows: 3,
            dataRows: 5
          },
          {
            code: 'statute',
            nodeRows: 3,
            dataRows: 5
          }
        ])
      }
    }
  },
  created() {
    const { path } = this.$route
    if (path === '/') {
      this.initNodeSubsets([
        {
          code: 'news',
          nodeRows: 3,
          dataRows: 6
        },
        {
          code: 'notice',
          nodeRows: 3,
          dataRows: 5
        },
        {
          code: 'statute',
          nodeRows: 3,
          dataRows: 5
        }
      ])
    }
  },
  methods: {
    ...mapActions({
      initNodeSubsets: 'cache/initNodeSubsets'
    })
  }

}
</script>

<style lang="scss" >
.app_contain_w{
  background: #fafafa;
}

</style>
